module.exports = __webpack_public_path__ + "static/media/search.d167b208.svg";